module.exports = __webpack_public_path__ + "img/Johnathan_Kong.04894479.png";